/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BadRequestErrorResponse,
    BadRequestErrorResponseFromJSON,
    BadRequestErrorResponseToJSON,
    ConflictErrorResponse,
    ConflictErrorResponseFromJSON,
    ConflictErrorResponseToJSON,
    CreateRescueRequest,
    CreateRescueRequestFromJSON,
    CreateRescueRequestToJSON,
    NotFoundErrorResponse,
    NotFoundErrorResponseFromJSON,
    NotFoundErrorResponseToJSON,
    RescueResponse,
    RescueResponseFromJSON,
    RescueResponseToJSON,
    UpdateRescueRequest,
    UpdateRescueRequestFromJSON,
    UpdateRescueRequestToJSON,
} from '../models';

export interface CreateRescueFirmwareRequest {
    createRescueRequest: CreateRescueRequest;
}

export interface ReadRescueByIdRequest {
    id: string;
}

export interface UpdateRescueFirmwareRequest {
    updateRescueRequest: UpdateRescueRequest;
}

/**
 * 
 */
export class RescueApi extends runtime.BaseAPI {

    /**
     * Create rescue firmware
     */
    async createRescueFirmwareRaw(requestParameters: CreateRescueFirmwareRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.createRescueRequest === null || requestParameters.createRescueRequest === undefined) {
            throw new runtime.RequiredError('createRescueRequest','Required parameter requestParameters.createRescueRequest was null or undefined when calling createRescueFirmware.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/rescues`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRescueRequestToJSON(requestParameters.createRescueRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create rescue firmware
     */
    async createRescueFirmware(requestParameters: CreateRescueFirmwareRequest, initOverrides?: RequestInit): Promise<void> {
        await this.createRescueFirmwareRaw(requestParameters, initOverrides);
    }

    /**
     * Returns all rescue configs from the config file.
     */
    async getRescuesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<RescueResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/rescues`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RescueResponseFromJSON));
    }

    /**
     * Returns all rescue configs from the config file.
     */
    async getRescues(initOverrides?: RequestInit): Promise<Array<RescueResponse>> {
        const response = await this.getRescuesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read rescue by ID.
     */
    async readRescueByIdRaw(requestParameters: ReadRescueByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<RescueResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readRescueById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/rescues/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RescueResponseFromJSON(jsonValue));
    }

    /**
     * Read rescue by ID.
     */
    async readRescueById(requestParameters: ReadRescueByIdRequest, initOverrides?: RequestInit): Promise<RescueResponse> {
        const response = await this.readRescueByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update rescue firmware
     */
    async updateRescueFirmwareRaw(requestParameters: UpdateRescueFirmwareRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.updateRescueRequest === null || requestParameters.updateRescueRequest === undefined) {
            throw new runtime.RequiredError('updateRescueRequest','Required parameter requestParameters.updateRescueRequest was null or undefined when calling updateRescueFirmware.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/rescues`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRescueRequestToJSON(requestParameters.updateRescueRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update rescue firmware
     */
    async updateRescueFirmware(requestParameters: UpdateRescueFirmwareRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateRescueFirmwareRaw(requestParameters, initOverrides);
    }

}
